import * as z from "zod";



const SchemaEntradaBase = z.object({
	id: z.uuid(),
	nombre: z.string().min(1, "El nombre es obligatorio"),
	tipo: z.literal("entrada"),
	subtipo: z.enum(["raw_co2", "materia_prima", "producto", "sub_proceso"]),
	cantidad: z.coerce
		.number<string | number>("La cantidad es obligatoria")
		.positive("La cantidad debe ser mayor que 0"),
	idProyecto: z.uuid(),
	idProcesoTo: z.uuid().nullable(),
});

export const SchemaEntradaRawCO2 = SchemaEntradaBase.extend({
	subtipo: z.literal("raw_co2"),
	unidad: z.literal("g"),
});
export type SchemaEntradaRawCO2 = z.infer<typeof SchemaEntradaRawCO2>;

export const SchemaEntradaMateriaPrima = SchemaEntradaBase.extend({
	subtipo: z.literal("materia_prima"),
	idMateriaPrima: z.uuid(),
	unidad: z.string(),
});
export type SchemaEntradaMateriaPrima = z.infer<typeof SchemaEntradaMateriaPrima>;

export const SchemaEntradaProducto = SchemaEntradaBase.extend({
	subtipo: z.literal("producto"),
	idProducto: z.uuid(),
	unidad: z.string(),

});
export type SchemaEntradaProducto = z.infer<typeof SchemaEntradaProducto>;

export const SchemaEntradaSubProceso = SchemaEntradaBase.extend({
	subtipo: z.literal("sub_proceso"),
	unidad: z.string(),
	externo: z.enum(["propio", "externo"], {
		error: "El tipo es obligatorio",
	}),
	alcance: z.enum(["cuna_puerta", "puerta_puerta"], {
		error: "El alcance es obligatorio",
	}),
});
export type SchemaEntradaSubProcesoIn = z.input<typeof SchemaEntradaSubProceso>;
export type SchemaEntradaSubProceso = z.infer<typeof SchemaEntradaSubProceso>;